import { render, staticRenderFns } from "./GeneralInfoReport.vue?vue&type=template&id=7f8075f8&scoped=true"
import script from "./GeneralInfoReport.vue?vue&type=script&lang=js"
export * from "./GeneralInfoReport.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfoReport.vue?vue&type=style&index=0&id=7f8075f8&prod&scoped=true&lang=css"
import style1 from "./GeneralInfoReport.vue?vue&type=style&index=1&id=7f8075f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8075f8",
  null
  
)

export default component.exports